import { combineReducers } from "@reduxjs/toolkit";
import { ChatData } from "./Public/chatreducer";
import { PrivateData } from "./Private/PrivateReducer";

export default combineReducers({ ChatData, PrivateData });
